import React from 'react';
import T from 'prop-types';

import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';

import {
  CustomDrag,
  Item,
  DragIcon,
} from './styles';

const DragHandle = SortableHandle(({ spaceRight, marginTop }) => (
  <CustomDrag
    spaceRight={spaceRight}
    marginTop={marginTop}
    onMouseDown={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
  >
    <DragIcon name="arrows alternate" />
  </CustomDrag>
));

const SortableItem = SortableElement(({
  component,
  spaceRight,
  noMargin,
  marginTop,
  index,
}) => (
  <Item key={index} noMargin={noMargin}>
    <DragHandle
      marginTop={marginTop}
      spaceRight={spaceRight}
    />
    {component}
  </Item>
));

const SortableComponent = SortableContainer(({
  items,
  spaceRight,
  marginTop,
  noMargin,
  disabled,
}) => (
  <div>
    {items.map((item, index) => (
      <SortableItem
        key={item.index}
        index={index}
        component={item}
        spaceRight={spaceRight}
        marginTop={marginTop}
        noMargin={noMargin}
        disabled={disabled}
      />
    ))}
  </div>
));

export const SortableList = ({
  items,
  onSortEnd,
  spaceRight,
  marginTop,
  noMargin,
  disabled,
  lockAxis,
}) => (
  <SortableComponent
    items={items}
    onSortEnd={onSortEnd}
    useDragHandle
    spaceRight={spaceRight}
    marginTop={marginTop}
    noMargin={noMargin}
    disabled={disabled}
    useWindowAsScrollContainer
    lockAxis={lockAxis}
  />
);

SortableList.defaultProps = {
  spaceRight: undefined,
  noMargin: undefined,
  marginTop: undefined,
  disabled: false,
  lockAxis: 'y',
};

SortableList.propTypes = {
  items: T.arrayOf(T.shape({})).isRequired,
  onSortEnd: T.func.isRequired,
  spaceRight: T.string,
  noMargin: T.bool,
  marginTop: T.string,
  disabled: T.bool,
  lockAxis: T.string,
};
